import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import { addEntities } from "../../entities";
import {
  FETCH_QUERY_USERS_FAILURE,
  FETCH_QUERY_USERS_REQUEST,
  FETCH_QUERY_USERS_SUCCESS
} from "../types";

const setPage = (limit, offset) => {
  if (limit && offset) {
    return offset / limit;
  }

  return 0;
};

const debounced = debounce(
  async (dispatch, schema, api, limit, offset, ordering, filters) => {
    let page = setPage(limit, offset);

    dispatch(
      createAction(FETCH_QUERY_USERS_REQUEST)({
        limit,
        offset,
        page,
        ordering,
        filters
      })
    );
    const response = await api.user.queryFetchUsers(
      ordering,
      limit,
      offset,
      filters
    );
    const data = normalize(response.results, [schema.user]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_QUERY_USERS_SUCCESS)({
        items: data.result,
        count: response.count,
        limit,
        offset,
        ordering,
        filters
      })
    );
    return response;
  },
  1000,
  { trailing: true }
);

export default (ordering, limit, offset, filters = {}) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(dispatch, schema, api, limit, offset, ordering, filters);
  } catch (err) {
    dispatch(createAction(FETCH_QUERY_USERS_FAILURE)(err));
    throw err;
  }
};
